// ***** Staff List CRUD Action Types *****

// Create New Staff "Create"
export const ADD_NEW_STAFF = "ADD_NEW_STAFF";
export const ADD_STAFF_SUCCESS = "ADD_STAFF_SUCCESS";
export const ADD_STAFF_FAIL = "ADD_STAFF_FAIL";

// GET Staff data "Read"
export const GET_STAFF_DATA = "GET_STAFF_DATA";
export const GET_STAFF_DATA_SUCCESS = "GET_STAFF_DATA_SUCCESS";
export const GET_STAFF_DATA_FAIL = "GET_STAFF_DATA_FAIL";

// Update Staff "Update"
export const UPDATE_STAFF = "UPDATE_STAFF";
export const UPDATE_STAFF_SUCCESS = "UPDATE_STAFF_SUCCESS";
export const UPDATE_STAFF_FAIL = "UPDATE_STAFF_FAIL";

// Delete Staff "Delete"
export const DELETE_STAFF = "DELETE_STAFF";
export const DELETE_STAFF_SUCCESS = "DELETE_STAFF_SUCCESS";
export const DELETE_STAFF_FAIL = "DELETE_STAFF_FAIL";

// Get Staff List
export const GET_STAFF_LIST = "GET_STAFF_LIST";
export const GET_STAFF_LIST_SUCCESS = "GET_STAFF_LIST_SUCCESS";
export const GET_STAFF_LIST_FAIL = "GET_STAFF_LIST_FAIL";

// Search Staff Income List
export const SEARCH_STAFF_INCOME_LIST = "SEARCH_STAFF_INCOME_LIST";
export const SEARCH_STAFF_INCOME_LIST_SUCCESS =
  "SEARCH_STAFF_INCOME_LIST_SUCCESS";
export const SEARCH_STAFF_INCOME_LIST_FAIL = "SEARCH_STAFF_INCOME_LIST_FAIL";

// Get Staff Leave type
export const GET_STAFF_LEAVE_TYPE_LIST = "GET_STAFF_LEAVE_TYPE_LIST";
export const GET_STAFF_LEAVE_TYPE_LIST_SUCCESS =
  "GET_STAFF_LEAVE_TYPE_LIST_SUCCESS";
export const GET_STAFF_LEAVE_TYPE_LIST_FAIL = "GET_STAFF_LEAVE_TYPE_LIST_FAIL";

// Add Staff Leave type
export const ADD_STAFF_LEAVE_TYPE = "ADD_STAFF_LEAVE_TYPE";
export const ADD_STAFF_LEAVE_TYPE_SUCCESS = "ADD_STAFF_LEAVE_TYPE_SUCCESS";
export const ADD_STAFF_LEAVE_TYPE_FAIL = "ADD_STAFF_LEAVE_TYPE_FAIL";

// Update Staff Leave type
export const UPDATE_STAFF_LEAVE_TYPE = "UPDATE_STAFF_LEAVE_TYPE";
export const UPDATE_STAFF_LEAVE_TYPE_SUCCESS =
  "UPDATE_STAFF_LEAVE_TYPE_SUCCESS";
export const UPDATE_STAFF_LEAVE_TYPE_FAIL = "UPDATE_STAFF_LEAVE_TYPE_FAIL";

// Delete Staff Leave type
export const DELETE_STAFF_LEAVE_TYPE = "DELETE_STAFF_LEAVE_TYPE";
export const DELETE_STAFF_LEAVE_TYPE_SUCCESS =
  "DELETE_STAFF_LEAVE_TYPE_SUCCESS";
export const DELETE_STAFF_LEAVE_TYPE_FAIL = "DELETE_STAFF_LEAVE_TYPE_FAIL";

//Get Staff Income List
export const GET_STAFF_INCOME_LIST = "GET_STAFF_INCOME_LIST";
export const GET_STAFF_INCOME_LIST_SUCCESS = "GET_STAFF_INCOME_LIST_SUCCESS";
export const GET_STAFF_INCOME_LIST_FAIL = "GET_STAFF_INCOME_LIST_FAIL";

// Get Staff Income data
export const GET_STAFF_INCOME_DATA = "GET_STAFF_INCOME_DATA";
export const GET_STAFF_INCOME_DATA_SUCCESS = "GET_STAFF_INCOME_DATA_SUCCESS";
export const GET_STAFF_INCOME_DATA_FAIL = "GET_STAFF_INCOME_DATA_FAIL";

// Update Staff Income
export const UPDATE_STAFF_INCOME = "UPDATE_STAFF_INCOME";
export const UPDATE_STAFF_INCOME_SUCCESS = "UPDATE_STAFF_INCOME_SUCCESS";
export const UPDATE_STAFF_INCOME_FAIL = "UPDATE_STAFF_INCOME_FAIL";

// Create Staff Income
export const CREATE_STAFF_INCOME = "CREATE_STAFF_INCOME";
export const CREATE_STAFF_INCOME_SUCCESS = "CREATE_STAFF_INCOME_SUCCESS";
export const CREATE_STAFF_INCOME_FAIL = "CREATE_STAFF_INCOME_FAIL";

// Delete Staff Income
export const DELETE_STAFF_INCOME = "DELETE_STAFF_INCOME";
export const DELETE_STAFF_INCOME_SUCCESS = "DELETE_STAFF_INCOME_SUCCESS";
export const DELETE_STAFF_INCOME_FAIL = "DELETE_STAFF_INCOME_FAIL";

//Staff Income Category Item List
export const GET_STAFF_INCOME_CATEGORY_ITEM_LIST =
  "GET_STAFF_INCOME_CATEGORY_ITEM_LIST";
export const GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS =
  "GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS";
export const GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL =
  "GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL";

//Staff Income Category Item data
export const GET_STAFF_INCOME_CATEGORY_ITEM_DATA =
  "GET_STAFF_INCOME_CATEGORY_ITEM_DATA";
export const GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS =
  "GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS";
export const GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL =
  "GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL";

//Create Staff Income Category Item data
export const CREATE_STAFF_INCOME_CATEGORY_ITEM =
  "CREATE_STAFF_INCOME_CATEGORY_ITEM";
export const CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS =
  "CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS";
export const CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL =
  "CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL";

//Update Staff Income Category Item data
export const UPDATE_STAFF_INCOME_CATEGORY_ITEM =
  "UPDATE_STAFF_INCOME_CATEGORY_ITEM";
export const UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS =
  "UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS";
export const UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL =
  "UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL";

//Delete Staff Income Category Item data
export const DELETE_STAFF_INCOME_CATEGORY_ITEM =
  "DELETE_STAFF_INCOME_CATEGORY_ITEM";
export const DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS =
  "DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS";
export const DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL =
  "DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL";

///staffleave/list
// Get Staff Leave List
export const GET_STAFF_LEAVE_LIST = "GET_STAFF_LEAVE_LIST";
export const GET_STAFF_LEAVE_LIST_SUCCESS = "GET_STAFF_LEAVE_LIST_SUCCESS";
export const GET_STAFF_LEAVE_LIST_FAIL = "GET_STAFF_LEAVE_LIST_FAIL";

///staffleave/data
// Get Staff Leave data
export const GET_STAFF_LEAVE_DATA = "GET_STAFF_LEAVE_DATA";
export const GET_STAFF_LEAVE_DATA_SUCCESS = "GET_STAFF_LEAVE_DATA_SUCCESS";
export const GET_STAFF_LEAVE_DATA_FAIL = "GET_STAFF_LEAVE_DATA_FAIL";

///staffleave/create
// Create Staff Leave
export const CREATE_STAFF_LEAVE = "CREATE_STAFF_LEAVE";
export const CREATE_STAFF_LEAVE_SUCCESS = "CREATE_STAFF_LEAVE_SUCCESS";
export const CREATE_STAFF_LEAVE_FAIL = "CREATE_STAFF_LEAVE_FAIL";

///staffleave/search
// Search Staff Leave
export const SEARCH_STAFF_LEAVE = "SEARCH_STAFF_LEAVE";
export const SEARCH_STAFF_LEAVE_SUCCESS = "SEARCH_STAFF_LEAVE_SUCCESS";
export const SEARCH_STAFF_LEAVE_FAIL = "SEARCH_STAFF_LEAVE_FAIL";

///staffleave/update
// Update Staff Leave
export const UPDATE_STAFF_LEAVE = "UPDATE_STAFF_LEAVE";
export const UPDATE_STAFF_LEAVE_SUCCESS = "UPDATE_STAFF_LEAVE_SUCCESS";
export const UPDATE_STAFF_LEAVE_FAIL = "UPDATE_STAFF_LEAVE_FAIL";

///staffleave/delete
// Delete Staff Leave
export const DELETE_STAFF_LEAVE = "DELETE_STAFF_LEAVE";
export const DELETE_STAFF_LEAVE_SUCCESS = "DELETE_STAFF_LEAVE_SUCCESS";
export const DELETE_STAFF_LEAVE_FAIL = "DELETE_STAFF_LEAVE_FAIL";

///staffleaveallowance/list
// Get Staff Leave Allowance List
export const GET_STAFF_LEAVE_ALLOWANCE_LIST = "GET_STAFF_LEAVE_ALLOWANCE_LIST";
export const GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS =
  "GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS";
export const GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL =
  "GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL";

///staffleaveallowance/data
// Get Staff Leave Allowance data
export const GET_STAFF_LEAVE_ALLOWANCE_DATA = "GET_STAFF_LEAVE_ALLOWANCE_DATA";
export const GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS =
  "GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS";
export const GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL =
  "GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL";
///staffleaveallowance/create
// Create Staff Leave Allowance
export const CREATE_STAFF_LEAVE_ALLOWANCE = "CREATE_STAFF_LEAVE_ALLOWANCE";
export const CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS =
  "CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS";
export const CREATE_STAFF_LEAVE_ALLOWANCE_FAIL =
  "CREATE_STAFF_LEAVE_ALLOWANCE_FAIL";
///staffleaveallowance/search
// Search Staff Leave Allowance
export const SEARCH_STAFF_LEAVE_ALLOWANCE = "SEARCH_STAFF_LEAVE_ALLOWANCE";
export const SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS =
  "SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS";
export const SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL =
  "SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL";

///staffleaveallowance/update
// Update Staff Leave Allowance
export const UPDATE_STAFF_LEAVE_ALLOWANCE = "UPDATE_STAFF_LEAVE_ALLOWANCE";
export const UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS =
  "UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS";
export const UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL =
  "UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL";

///staffleaveallowance/delete
// Delete Staff Leave Allowance
export const DELETE_STAFF_LEAVE_ALLOWANCE = "DELETE_STAFF_LEAVE_ALLOWANCE";
export const DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS =
  "DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS";
export const DELETE_STAFF_LEAVE_ALLOWANCE_FAIL =
  "DELETE_STAFF_LEAVE_ALLOWANCE_FAIL";

///staff/search
// Search Staff
export const SEARCH_STAFF = "SEARCH_STAFF";
export const SEARCH_STAFF_SUCCESS = "SEARCH_STAFF_SUCCESS";
export const SEARCH_STAFF_FAIL = "SEARCH_STAFF_FAIL";

///staff/search/myteammembers
// Search Staff Members
export const SEARCH_STAFF_MEMBERS = "SEARCH_STAFF_MEMBERS";
export const SEARCH_STAFF_MEMBERS_SUCCESS = "SEARCH_STAFF_MEMBERS_SUCCESS";
export const SEARCH_STAFF_MEMBERS_FAIL = "SEARCH_STAFF_MEMBERS_FAIL";

// create staff and user /create/user
export const CREATE_STAFF_AND_USER = "CREATE_STAFF_AND_USER";
export const CREATE_STAFF_AND_USER_SUCCESS = "CREATE_STAFF_AND_USER_SUCCESS";
export const CREATE_STAFF_AND_USER_FAIL = "CREATE_STAFF_AND_USER_FAIL";

///organisationdepartmenttostaff/list
// Get Organisation Department To Staff List
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST";
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS";
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL";

///organisationdepartmenttostaff/data
// Get Organisation Department To Staff data
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA";
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS";
export const GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL =
  "GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL";

///organisationdepartmenttostaff/create
// Create Organisation Department To Staff
export const CREATE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "CREATE_ORGANISATION_DEPARTMENT_TO_STAFF";
export const CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS =
  "CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS";
export const CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL =
  "CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL";

///organisationdepartmenttostaff/search
// Search Organisation Department To Staff
export const SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF =
  "SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF";
export const SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS =
  "SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS";
export const SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL =
  "SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL";

///organisationdepartmenttostaff/update
// Update Organisation Department To Staff
export const UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF";
export const UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS =
  "UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS";
export const UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL =
  "UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL";

///organisationdepartmenttostaff/delete
// Delete Organisation Department To Staff
export const DELETE_ORGANISATION_DEPARTMENT_TO_STAFF =
  "DELETE_ORGANISATION_DEPARTMENT_TO_STAFF";
export const DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS =
  "DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS";
export const DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL =
  "DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL";

///organisationdepartment/list
// Get Organisation Department List
export const GET_ORGANISATION_DEPARTMENT_LIST =
  "GET_ORGANISATION_DEPARTMENT_LIST";
export const GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS =
  "GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS";
export const GET_ORGANISATION_DEPARTMENT_LIST_FAIL =
  "GET_ORGANISATION_DEPARTMENT_LIST_FAIL";

///organisationdepartment/data
// Get Organisation Department data
export const GET_ORGANISATION_DEPARTMENT_DATA =
  "GET_ORGANISATION_DEPARTMENT_DATA";
export const GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS =
  "GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS";
export const GET_ORGANISATION_DEPARTMENT_DATA_FAIL =
  "GET_ORGANISATION_DEPARTMENT_DATA_FAIL";

///organisationdepartment/create
// Create Organisation Department
export const CREATE_ORGANISATION_DEPARTMENT = "CREATE_ORGANISATION_DEPARTMENT";
export const CREATE_ORGANISATION_DEPARTMENT_SUCCESS =
  "CREATE_ORGANISATION_DEPARTMENT_SUCCESS";
export const CREATE_ORGANISATION_DEPARTMENT_FAIL =
  "CREATE_ORGANISATION_DEPARTMENT_FAIL";

///organisationdepartment/hierarchy/enquiry
// Get Organisation Department Hierarchy Enquiry
export const GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY =
  "GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY";
export const GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS =
  "GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS";
export const GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL =
  "GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL";

///organisationdepartment/update
// Update Organisation Department
export const UPDATE_ORGANISATION_DEPARTMENT = "UPDATE_ORGANISATION_DEPARTMENT";
export const UPDATE_ORGANISATION_DEPARTMENT_SUCCESS =
  "UPDATE_ORGANISATION_DEPARTMENT_SUCCESS";
export const UPDATE_ORGANISATION_DEPARTMENT_FAIL =
  "UPDATE_ORGANISATION_DEPARTMENT_FAIL";

///organisationdepartment/delete
// Delete Organisation Department
export const DELETE_ORGANISATION_DEPARTMENT = "DELETE_ORGANISATION_DEPARTMENT";
export const DELETE_ORGANISATION_DEPARTMENT_SUCCESS =
  "DELETE_ORGANISATION_DEPARTMENT_SUCCESS";
export const DELETE_ORGANISATION_DEPARTMENT_FAIL =
  "DELETE_ORGANISATION_DEPARTMENT_FAIL";

///stafftostaffmanager/list
// Get Staff To Staff Manager List
export const GET_STAFF_TO_STAFF_MANAGER_LIST =
  "GET_STAFF_TO_STAFF_MANAGER_LIST";
export const GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS =
  "GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS";
export const GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL =
  "GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL";

///stafftostaffmanager/data
// Get Staff To Staff Manager data
export const GET_STAFF_TO_STAFF_MANAGER_DATA =
  "GET_STAFF_TO_STAFF_MANAGER_DATA";
export const GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS =
  "GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS";
export const GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL =
  "GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL";

///stafftostaffmanager/create
// Create Staff To Staff Manager
export const CREATE_STAFF_TO_STAFF_MANAGER = "CREATE_STAFF_TO_STAFF_MANAGER";
export const CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS =
  "CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS";
export const CREATE_STAFF_TO_STAFF_MANAGER_FAIL =
  "CREATE_STAFF_TO_STAFF_MANAGER_FAIL";

///stafftostaffmanager/update
// Update Staff To Staff Manager
export const UPDATE_STAFF_TO_STAFF_MANAGER = "UPDATE_STAFF_TO_STAFF_MANAGER";
export const UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS =
  "UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS";
export const UPDATE_STAFF_TO_STAFF_MANAGER_FAIL =
  "UPDATE_STAFF_TO_STAFF_MANAGER_FAIL";

///stafftostaffmanager/delete
// Delete Staff To Staff Manager
export const DELETE_STAFF_TO_STAFF_MANAGER = "DELETE_STAFF_TO_STAFF_MANAGER";
export const DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS =
  "DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS";
export const DELETE_STAFF_TO_STAFF_MANAGER_FAIL =
  "DELETE_STAFF_TO_STAFF_MANAGER_FAIL";

///staffrecentactivity/list/
// Get Staff Recent Activity List
export const GET_STAFF_RECENT_ACTIVITY_LIST = "GET_STAFF_RECENT_ACTIVITY_LIST";
export const GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS =
  "GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS";
export const GET_STAFF_RECENT_ACTIVITY_LIST_FAIL =
  "GET_STAFF_RECENT_ACTIVITY_LIST_FAIL";

///staff/search/realtime
// Search Staff Real Time
export const SEARCH_STAFF_REAL_TIME = "SEARCH_STAFF_REAL_TIME";
export const SEARCH_STAFF_REAL_TIME_SUCCESS = "SEARCH_STAFF_REAL_TIME_SUCCESS";
export const SEARCH_STAFF_REAL_TIME_FAIL = "SEARCH_STAFF_REAL_TIME_FAIL";

///staffskillset/list
// Get Staff Skill Set List
export const GET_STAFF_SKILL_SET_LIST = "GET_STAFF_SKILL_SET_LIST";
export const GET_STAFF_SKILL_SET_LIST_SUCCESS =
  "GET_STAFF_SKILL_SET_LIST_SUCCESS";
export const GET_STAFF_SKILL_SET_LIST_FAIL = "GET_STAFF_SKILL_SET_LIST_FAIL";

///staffskillset/data
// Get Staff Skill Set data
export const GET_STAFF_SKILL_SET_DATA = "GET_STAFF_SKILL_SET_DATA";
export const GET_STAFF_SKILL_SET_DATA_SUCCESS =
  "GET_STAFF_SKILL_SET_DATA_SUCCESS";
export const GET_STAFF_SKILL_SET_DATA_FAIL = "GET_STAFF_SKILL_SET_DATA_FAIL";

///staffskillset/create
// Create Staff Skill Set
export const CREATE_STAFF_SKILL_SET = "CREATE_STAFF_SKILL_SET";
export const CREATE_STAFF_SKILL_SET_SUCCESS = "CREATE_STAFF_SKILL_SET_SUCCESS";
export const CREATE_STAFF_SKILL_SET_FAIL = "CREATE_STAFF_SKILL_SET_FAIL";

///staffskillset/update
// Update Staff Skill Set
export const UPDATE_STAFF_SKILL_SET = "UPDATE_STAFF_SKILL_SET";
export const UPDATE_STAFF_SKILL_SET_SUCCESS = "UPDATE_STAFF_SKILL_SET_SUCCESS";
export const UPDATE_STAFF_SKILL_SET_FAIL = "UPDATE_STAFF_SKILL_SET_FAIL";

///staffskillset/delete
// Delete Staff Skill Set
export const DELETE_STAFF_SKILL_SET = "DELETE_STAFF_SKILL_SET";
export const DELETE_STAFF_SKILL_SET_SUCCESS = "DELETE_STAFF_SKILL_SET_SUCCESS";
export const DELETE_STAFF_SKILL_SET_FAIL = "DELETE_STAFF_SKILL_SET_FAIL";

///stafftostaffskillset/list
// Get Staff To Staff Skill Set List
export const GET_STAFF_TO_STAFF_SKILL_SET_LIST =
  "GET_STAFF_TO_STAFF_SKILL_SET_LIST";
export const GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS =
  "GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS";
export const GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL =
  "GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL";

///stafftostaffskillset/list/active
// Get Active Staff To Staff Skill Set List
export const GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST =
  "GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST";
export const GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS =
  "GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS";
export const GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL =
  "GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL";

///stafftostaffskillset/list/expired
// Get Expired Staff To Staff Skill Set List
export const GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST =
  "GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST";
export const GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS =
  "GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS";
export const GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL =
  "GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL";

///stafftostaffskillset/data/
// Get Staff To Staff Skill Set data
export const GET_STAFF_TO_STAFF_SKILL_SET_DATA =
  "GET_STAFF_TO_STAFF_SKILL_SET_DATA";
export const GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS =
  "GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS";
export const GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL =
  "GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL";

///stafftostaffskillset/create
// Create Staff To Staff Skill Set
export const CREATE_STAFF_TO_STAFF_SKILL_SET =
  "CREATE_STAFF_TO_STAFF_SKILL_SET";
export const CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS =
  "CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS";
export const CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL =
  "CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL";

///stafftostaffskillset/update
// Update Staff To Staff Skill Set
export const UPDATE_STAFF_TO_STAFF_SKILL_SET =
  "UPDATE_STAFF_TO_STAFF_SKILL_SET";
export const UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS =
  "UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS";
export const UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL =
  "UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL";

///stafftostaffskillset/delete
// Delete Staff To Staff Skill Set
export const DELETE_STAFF_TO_STAFF_SKILL_SET =
  "DELETE_STAFF_TO_STAFF_SKILL_SET";
export const DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS =
  "DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS";
export const DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL =
  "DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL";

///stafftostaffskillset/search
// Search Staff To Staff Skill Set
export const SEARCH_STAFF_TO_STAFF_SKILL_SET =
  "SEARCH_STAFF_TO_STAFF_SKILL_SET";
export const SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS =
  "SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS";
export const SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL =
  "SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL";
///staff/search/availability
// Search Staff Availability
export const SEARCH_STAFF_AVAILABILITY = "SEARCH_STAFF_AVAILABILITY";
export const SEARCH_STAFF_AVAILABILITY_SUCCESS =
  "SEARCH_STAFF_AVAILABILITY_SUCCESS";
export const SEARCH_STAFF_AVAILABILITY_FAIL = "SEARCH_STAFF_AVAILABILITY_FAIL";
///staffgpslocationhistory/search
// Search Staff GPS Location History
export const SEARCH_STAFF_GPS_LOCATION_HISTORY =
  "SEARCH_STAFF_GPS_LOCATION_HISTORY";
export const SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS =
  "SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS";
export const SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL =
  "SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL";
///staffworkingschedulerecord/list
// Get Staff Working Schedule Record List
export const GET_STAFF_WORKING_SCHEDULE_RECORD_LIST =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_LIST";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL";
///staffworkingschedulerecord/data
// Get Staff Working Schedule Record data
export const GET_STAFF_WORKING_SCHEDULE_RECORD_DATA =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_DATA";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL";

///staffworkingschedulerecord/create
// Create Staff Working Schedule Record
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD";
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS";
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL";

///staffworkingschedulerecord/update
// Update Staff Working Schedule Record
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD";
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS";
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL";

///staffworkingschedulerecord/delete
// Delete Staff Working Schedule Record
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD";
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS";
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL";

///staffworkingschedulerecordadjustment/list
// Get Staff Working Schedule Record Adjustment List
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL";

///staffworkingschedulerecordadjustment/data
// Get Staff Working Schedule Record Adjustment data
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL";

///staffworkingschedulerecordadjustment/create
// Create Staff Working Schedule Record Adjustment
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT";
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS";
export const CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL =
  "CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL";

///staffworkingschedulerecordadjustment/update
// Update Staff Working Schedule Record Adjustment
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT";
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS";
export const UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL =
  "UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL";

///staffworkingschedulerecordadjustment/delete
// Delete Staff Working Schedule Record Adjustment
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT";
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS";
export const DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL =
  "DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL";

///staffworkingschedule/list
// Get Staff Working Schedule List
export const GET_STAFF_WORKING_SCHEDULE_LIST =
  "GET_STAFF_WORKING_SCHEDULE_LIST";
export const GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_LIST_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_LIST_FAIL";

///staffworkingschedule/data
// Get Staff Working Schedule data
export const GET_STAFF_WORKING_SCHEDULE_DATA =
  "GET_STAFF_WORKING_SCHEDULE_DATA";
export const GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS =
  "GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS";
export const GET_STAFF_WORKING_SCHEDULE_DATA_FAIL =
  "GET_STAFF_WORKING_SCHEDULE_DATA_FAIL";

///staffworkingschedule/create
// Create Staff Working Schedule
export const CREATE_STAFF_WORKING_SCHEDULE = "CREATE_STAFF_WORKING_SCHEDULE";
export const CREATE_STAFF_WORKING_SCHEDULE_SUCCESS =
  "CREATE_STAFF_WORKING_SCHEDULE_SUCCESS";
export const CREATE_STAFF_WORKING_SCHEDULE_FAIL =
  "CREATE_STAFF_WORKING_SCHEDULE_FAIL";

///staffworkingschedule/update
// Update Staff Working Schedule
export const UPDATE_STAFF_WORKING_SCHEDULE = "UPDATE_STAFF_WORKING_SCHEDULE";
export const UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS =
  "UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS";
export const UPDATE_STAFF_WORKING_SCHEDULE_FAIL =
  "UPDATE_STAFF_WORKING_SCHEDULE_FAIL";

///staffworkingschedule/delete
// Delete Staff Working Schedule
export const DELETE_STAFF_WORKING_SCHEDULE = "DELETE_STAFF_WORKING_SCHEDULE";
export const DELETE_STAFF_WORKING_SCHEDULE_SUCCESS =
  "DELETE_STAFF_WORKING_SCHEDULE_SUCCESS";
export const DELETE_STAFF_WORKING_SCHEDULE_FAIL =
  "DELETE_STAFF_WORKING_SCHEDULE_FAIL";

///staffworkingschedule/search
// Search Staff working schedule
export const SEARCH_STAFF_WORKING_SCHEDULE = "SEARCH_STAFF_WORKING_SCHEDULE";
export const SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS =
  "SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS";
export const SEARCH_STAFF_WORKING_SCHEDULE_FAIL =
  "SEARCH_STAFF_WORKING_SCHEDULE_FAIL";

///staffworkingschedule/search (isolated channel — clone from another staff)
// Search Staff working schedule for cloning into the current staff
export const SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE =
  "SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE";
export const SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS =
  "SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS";
export const SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL =
  "SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL";

///staffworkingschedule/calculate
// Calculate Staff Working Schedule
export const CALCULATE_STAFF_WORKING_SCHEDULE =
  "CALCULATE_STAFF_WORKING_SCHEDULE";
export const CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS =
  "CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS";
export const CALCULATE_STAFF_WORKING_SCHEDULE_FAIL =
  "CALCULATE_STAFF_WORKING_SCHEDULE_FAIL";

///staffactivitylog/search
export const STAFF_ACTIVITY_LOG_SEARCH = "STAFF_ACTIVITY_LOG_SEARCH";
export const STAFF_ACTIVITY_LOG_SEARCH_SUCCESS =
  "STAFF_ACTIVITY_LOG_SEARCH_SUCCESS";
export const STAFF_ACTIVITY_LOG_SEARCH_FAILURE =
  "STAFF_ACTIVITY_LOG_SEARCH_FAILURE";
